const state = () => ({
    theme: false
})

const mutations = {
    setTheme(state, { theme }) {
        state.theme = theme
    },
    clearAll(state) {
        state.theme = false
    }
}

const actions = {
    async setTheme({ commit }, { theme }) {
        commit('setTheme', { theme })
    },
    async clearAll({ commit }) {
        commit('clearAll')
    }
}

const getters = {
    theme: state => state.theme
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};